export const getVerifierNameById = (id: string) => {
  switch (id) {
    case '938052d4-3930-4ce9-bc96-bbb5a5884324':
      return 'Valentina Vaquero';
    case '0121eb29-1984-465b-9ef0-7d434fd2378d':
      return 'Diana Piñeiro';
    case 'da032128-4734-4d17-ac3e-2acae3ebca0f':
      return 'Tomas Herrero';
    case '54269154-f622-4682-b0db-bcceffbe15e0':
      return 'Luisana Gomez';
    case '94a15045-4a22-4885-b367-3b94a19f68a9':
      return 'Enric Gilabert';
    default:
      return id;
  }
};
